import React from 'react'
import { Box, Button, Chip, Typography } from '@mui/material'
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined'
import HistoryIcon from '@mui/icons-material/History'
import { CopilotEntityType } from './types'

const CANNED_PROMPTS: Record<CopilotEntityType, string[]> = {
  pattern: [
    'Build a simple EMA crossover entry',
    'Add an RSI overbought filter to this pattern',
    'Explain what this pattern does',
  ],
  indicator: [
    'Build ATR smoothed by a 15-period SMA',
    'Turn RSI into a 0-100 weighted momentum score',
    'Explain what this indicator measures',
  ],
}

interface CopilotEmptyStateProps {
  entityType: CopilotEntityType
  entityName: string
  canResume: boolean
  onResume: () => void
  onPrompt: (text: string) => void
}

const CopilotEmptyState: React.FC<CopilotEmptyStateProps> = ({
  entityType,
  entityName,
  canResume,
  onResume,
  onPrompt,
}) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    gap={1.5}
    sx={{ height: '100%', p: 2, textAlign: 'center' }}
  >
    <SmartToyOutlinedIcon sx={{ fontSize: 32, color: 'primary.main', opacity: 0.8 }} />
    <Typography variant="subtitle1">Build with AI</Typography>
    <Typography variant="body2" color="text.secondary">
      Describe changes to “{entityName}” and watch them appear in the editor. You can hand-edit
      between turns — the assistant always works from what's on screen.
    </Typography>
    <Box display="flex" flexDirection="column" gap={0.75} sx={{ width: '100%' }}>
      {CANNED_PROMPTS[entityType].map((prompt) => (
        <Chip
          key={prompt}
          label={prompt}
          variant="outlined"
          onClick={() => onPrompt(prompt)}
          sx={{ justifyContent: 'flex-start' }}
        />
      ))}
    </Box>
    {canResume && (
      <Button size="small" startIcon={<HistoryIcon />} onClick={onResume}>
        Resume previous session
      </Button>
    )}
  </Box>
)

export default CopilotEmptyState
